import { persist } from 'zustand/middleware'
import { create } from 'zustand'
import { CallData } from '../types'

type AttendanceCallStore = {
  attendanceCall: CallData
  setAttendanceCall: (guideNumber: CallData) => void
}

export const useAttendanceCallStore = create<AttendanceCallStore>()(
  persist(
    (set, get) => {
      return {
        attendanceCall: null,
        setAttendanceCall: (call: CallData) => {
          set({
            attendanceCall: {
              ...get().attendanceCall,
              ...call,
            },
          })
        },
      }
    },
    {
      name: 'call',
      getStorage: () => sessionStorage,
    },
  ),
)
